import Modal from '@src/common/Modal';
import React,{ useEffect, useState, useCallback } from 'react';
import {InsuranceDate} from '@src/common/DatePicker';
import moment from 'moment';
import * as HELPER from "@src/config/helper";
import { COMMISSION_MAIN_TAB_KEY, FILTER_TYPE, ROLE } from '@src/config/id/constant';
import ReactSelect from '@common/ReactSelect';
import { getMasterConfigID, getReporteeID } from '@src/store/slices/common';
import { useDispatch,useSelector } from 'react-redux'
import MultiSelect from "@common/MultiSelect";
import secureStorage from "@src/config/encrypt";
import FullPageLoader from '@common/FullPageLoader';
import { useLanguage } from '@src/context/LanguageContext';
import { toast } from 'react-toastify';


interface CommonModelProps {
    show: boolean;
    handleClose: () => void;
    filterType: string;
    showDateRange?:boolean,
    buttonTitle?:string,
    api?:(params:any) => void,
    selectedFilters?:any,
    setSelectedFilters?:any,
    data?:any,
    mainTab?:any,
    className?:string
}

const CommonModel = ({show,handleClose,filterType,showDateRange,buttonTitle,api,selectedFilters,setSelectedFilters,data,mainTab,className}: CommonModelProps) => {

    const [loading, setLoading] = useState(false);
    const commonState = useSelector((state: any) => state.common);
    const [bankData,setBankData] = useState<any>(commonState?.common?.oto_bank_details);
    const dispatch: any = useDispatch();
    const {translations} = useLanguage();
     
    const [masterConfig,setMasterConfig] = useState<any>(null);
    const [userNameOptions, setUserNameOptions] = useState<any[]>([]);
    const user_data = secureStorage.getItem("authAgentUserInfo");
     
    const fetchMasterConfig = useCallback(async () => {
        try {
          setLoading(true);
          const res: any = await dispatch(getMasterConfigID());
          if(res.status===200){
            setMasterConfig(res.data);
            setBankData(res.data.oto_bank_details)
          }
          setLoading(false);
        } catch (error) {
          console.error("Failed to fetch master config:", error);
        }
      }, [dispatch]);

    
        useEffect(() => {
          if ((!commonState?.common || Object.keys(commonState.common).length === 0) && (statusList.length === 0 || masterConfig?.insurer_list.length === 0)) {
            fetchMasterConfig();
          }
        }, [commonState?.common]);
    

    const [appliedFilter, setAppliedFilter] = useState<any>({
        to_date:null,
        from_date:null,
        insurer_id: [],
        status: null,
        user_name: [],
        user_role: []
    });
    

    const [errField, setErrField] = useState<any>({
        from_date : "",
        to_date: ""
    });
 

    useEffect(() => {
        if (selectedFilters) {
            setAppliedFilter(selectedFilters);
        }
    }, [selectedFilters]);


    const handleDateChange = (field: string, date: Date) => {
        setAppliedFilter((prev: any) => {
            const formattedDate = moment(date).format("YYYY-MM-DD");

            if (field === "from_date") {
                // Reset to_date if from_date changes
                const toDate = prev.to_date && moment(prev.to_date);
                return {
                    ...prev,
                    from_date: formattedDate,
                    to_date: toDate && moment(formattedDate).isAfter(toDate) ? null : prev.to_date,
                };
            }

            if (field === "to_date") {
                return {
                    ...prev,
                    to_date: formattedDate,
                };
            }

            return { ...prev, [field]: formattedDate };
        });
    };

    const validateForm = () => {
        let formIsValid = true;
        setErrField({
            from_date : "",
            to_date: ""
        });
        if (appliedFilter[filterType] === "cdr") {
            // Validate from_date
            if (!appliedFilter.from_date) {
                setErrField((prevState: any) => ({
                    ...prevState,
                    from_date: "From Date is required.",
                }));
                formIsValid = false;
            }
            // Validate to_date
            if (!appliedFilter.to_date) {
                setErrField((prevState: any) => ({
                    ...prevState,
                    to_date: "To Date is required.",
                }));
                formIsValid = false;
            } else if (appliedFilter.from_date && appliedFilter.to_date < appliedFilter.from_date) {
                setErrField((prevState: any) => ({
                    ...prevState,
                    to_date: "To Date cannot be earlier than From Date.",
                }));
                formIsValid = false;
            }
        }
        return formIsValid;
    }

    const DetailRow = ({ label, value }: { label: string; value: string }) => (
        <div className="detail-row">
            <span className="detail-label">{label}</span>
            <span className="detail-value">{value}</span>
        </div>
    );
    const downloadFile = async (files: any[] = []) => {
        const validFiles = files.flat().filter((file: any) => file?.doc_path);

        for (const [index, file] of validFiles.entries()) {
            try {
                const response = await fetch(file.doc_path);

                if (!response.ok) {
                    throw new Error("Failed to download file");
                }

                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                const fileName = file.name || file.doc_path.split("?")[0].split("/").pop() || `file_${index}.pdf`;

                link.href = blobUrl;
                link.download = fileName;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                toast.error("Unable to download file.");
            }
        }
    };

    const applyFilter = () => {
        if (validateForm()) {
            let appliedFilterPayload: any = {...selectedFilters};
            delete appliedFilterPayload.filter_status_list;
            delete appliedFilterPayload.role_id; 
            
            if(showDateRange){
                appliedFilterPayload.from_date = appliedFilter.from_date;
                appliedFilterPayload.to_date = appliedFilter.to_date;
            }
             // INSURER IDs 
            if (appliedFilter?.insurer_id?.length) {
                appliedFilterPayload.insurer_id = appliedFilter.insurer_id;
            }
            else {
                delete appliedFilterPayload.insurer_id;
            }

         // STATUS ID → always array
        if (appliedFilter?.status) {
            appliedFilterPayload.filter_status_id = [appliedFilter.status.value];
        } else {
            delete appliedFilterPayload.filter_status_id;
        }

        if (appliedFilter?.user_name?.length) {
            appliedFilterPayload.reportee_user_id = String(appliedFilter.user_name[0]);
        } else {
            delete appliedFilterPayload.reportee_user_id;
        }

            if (appliedFilter?.user_role?.length) {
                appliedFilterPayload.reportee_role_id = String(appliedFilter.user_role[0]);
            } else {
                delete appliedFilterPayload.reportee_role_id;
            }

            setSelectedFilters(appliedFilterPayload)
            api?.(appliedFilterPayload)
            handleClose();
        }
    };
    
    const elements = document.getElementsByClassName("modal-main");

    Array.from(elements).forEach((el) => {
        (el as HTMLElement).style.width = "550px";
    });
    
    const insurerOptions = masterConfig?.insurer_list?.map((item: any) => ({ label: item.label,value: item.value, })) || [];


    const handleSelectChange = (event: any, key: string) => {
        let value: any = [];

        if (Array.isArray(event)) {
            value = event.map(item => item.value);
        }
        // SINGLE SELECT (ReactSelect fallback)
        else if (event?.value) {
            value = [event.value];
        }

        setAppliedFilter((prev: any) => ({
            ...prev,
            [key]: value,
        }));
    };


    const makeInsurerChips = () => {
    let chipsHtml: any[] = [];

    if (
        Array.isArray(appliedFilter?.insurer_id) && appliedFilter.insurer_id.length) {
        appliedFilter.insurer_id.forEach((value: any) => {
            const option = insurerOptions.find(
                (opt: any) => opt.value === value
            );

            if (!option) return;

            chipsHtml.push(
                <li key={value}>
                    {option.label}
                    <span
                        onClick={() => {
                            setAppliedFilter((prev: any) => ({
                                ...prev,
                                insurer_id: prev.insurer_id.filter(
                                    (id: any) => id !== value
                                ),
                            }));

                            setSelectedFilters((prev: any) => ({
                                ...prev,
                                insurer_id: prev?.insurer_id?.filter(
                                    (id: any) => id !== value
                                ) || []
                            }));
                        }
                        }
                    >
                        <i className="ic-clearclose"></i>
                    </span>
                </li>
            );
        });
    }

    return chipsHtml;
};

     
    useEffect(() => {
        if (statusList.length === 0 || masterConfig?.insurer_list.length === 0) {
            fetchMasterConfig();
        }
    }, []);

    const statusList = masterConfig?.filter_status_list || [];

    // reset value during open modal
   useEffect(() => {
    if (show && selectedFilters) {
        let statusObj = null;

        if (selectedFilters?.filter_status_id?.length) {
            const id = selectedFilters.filter_status_id[0];
            statusObj = statusList.find((s: any) => s.value === id) || null;
        }

        setAppliedFilter({
            ...selectedFilters,
            status: statusObj
        });
    }
}, [show, selectedFilters, statusList]);




    const fetchAgent = async (params: any) => {
        try {
            setLoading(true);

            let res: any = await dispatch(getReporteeID(params));

            res = res?.map((row: any) => ({
                label: row?.name,
                value: row?.id,
            }));

            return res;
        } catch (error) {
            console.error("fetchAgent error:", error);
            return [];
        } finally {
            setLoading(false);
        }
    };


   useEffect(() => {
  const loadAgents = async () => {
    const agents = await fetchAgent({
      role_id: user_data?.user_data?.role_id,
      user_id: user_data?.user_data?.id,
    });

    setUserNameOptions(agents || []);
  };

  if (user_data?.user_data?.id) {
    loadAgents();
  }
}, [user_data?.user_data?.id]);


const selectedRole = masterConfig?.sfa_roles?.find( (role: any) => (role?.value - 1) === user_data?.user_data?.role_id);

    useEffect(() => {
        if (show) document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])

    const handleCopy = (url:string) => {
                navigator.clipboard.writeText(url);
                toast.success("Payment link copied to clipboard");
    };
    

    return(
        <React.Fragment>
            <FullPageLoader show={loading} /> 
             {/* upload-error-popup dashboard-filter-popup */}
            <div className= {`model-outer ${filterType === "Get Help" ? "get-helpPopup faq-popup":"get-helpPopup filterpopup"} ${className || ''}`}>
            <Modal show={show} handleClose={handleClose}>
                <div className="modal-header">
            {filterType !== "Get Help" && (<h2>{filterType ==="Bank Details"?bankData?.title:filterType}</h2>)}
          </div>
                <div className="modal-body">
                    <div className='row'>
                        {filterType=== "Filters" &&
                        <>
                        {/* Select Status */}
                            <div className="col-md-12">
                                <span className="date-range"> {translations?.COMMON_MSG?.SELECT_STATUS}</span>

                                {statusList.map(
                                    (status:any, index:any) => (
                                        <fieldset
                                            key={status.value}
                                            className="form-filed common-application-checkbox"
                                        >
                                            <div className="custom-control custom-checkbox">
                                                <input
                                                    id={`status_${status.value}`}
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    checked={appliedFilter?.status?.value === status.value}
                                                    onChange={(e) => {
                                                        setAppliedFilter((prev: any) => ({
                                                            ...prev,status: e.target.checked ? status : null
                                                        }));
                                                    }}
                                                />

                                                <label
                                                    htmlFor={`status_${status.value}`}
                                                    className="custom-control-label checkbox-label-txt"
                                                >
                                                    {/* <span className="addon-list-heading">{status}</span> */}
                                                    {status.label}
                                                </label>
                                            </div>
                                        </fieldset>
                                    )
                                )}
                            </div>


                            {/* Insurer Name */}
                            <div className="col-md-12">
                                <span className="date-range"> {translations?.COMMON_MSG?.INSURER_NAME}</span>
                                     <fieldset className="multiselect-dropDown">
                                        <div className="material">
                                            <MultiSelect
                                                options={insurerOptions}
                                                isSelectAll={true}
                                                value={insurerOptions.filter((opt: any) =>
                                                    appliedFilter?.insurer_id?.includes(opt.value)
                                                )}
                                                onChange={(e: any) => handleSelectChange(e, "insurer_id")}
                                                placeholder={""}
                                                isClearable={false}
                                            />
                                        </div>
                                    </fieldset>

                                {/* Selected Insurer Chips */}
                                {appliedFilter?.insurer_id?.length > 0 && (
                                    <div className="selected-chips selected-chip-filter">
                                        <ul>{makeInsurerChips()}</ul>
                                    </div>
                                )}
                            </div>

                        </>
                        }

                        <div className='col-md-12 col-xs-12'>
                        {
                            showDateRange && (
                                <span className='date-range'>{translations?.COMMON_MSG?.DATE_RANGE}</span>
                            )
                        }
                        </div>
                        {
                            showDateRange &&
                            <>
                                <div className='col-md-6'>
                                    <fieldset>
                                        <div className={(appliedFilter && appliedFilter?.from_date)?`material animation-effect active-label`:`material animation-effect`}>
                                            <InsuranceDate
                                                onChange={(e: Date) => handleDateChange('from_date', e)}
                                                placeholder=""
                                                text={translations?.COMMON_MSG?.FROM_DATE}
                                                value={appliedFilter.from_date || ""}
                                            />
                                            {errField.from_date && (
                                                <span className="error-txt">
                                                    {errField['from_date'] || ""}
                                                </span>
                                            )}
                                        </div>
                                    </fieldset>
                                </div>
                                <div className='col-md-6'>
                                    <fieldset>
                                        <div className={(appliedFilter && appliedFilter?.to_date)?`material animation-effect active-label`:`material animation-effect`}>
                                            <InsuranceDate
                                                onChange={(e: Date) => handleDateChange('to_date', e)}
                                                placeholder=""
                                                text={translations?.COMMON_MSG?.TO_DATE}
                                                value={appliedFilter.to_date || ""}
                                            />
                                            {errField.to_date && (
                                                <span className="error-txt">
                                                    {errField['to_date'] || ""}
                                                </span>
                                            )}
                                        </div>
                                    </fieldset>
                                </div>
                            </>
                        }
                        {/* {(user_data?.user_data?.role_id === ROLE.BM || user_data?.user_data?.role_id === ROLE.VP) &&
                        <>
                            <div className="col-md-12">
                                <span className="date-range">User Role</span>
                                <div className="material">

                                        <ReactSelect
                                            options={selectedRole ? [selectedRole] : []}
                                            value={ masterConfig?.sfa_roles?.filter((option: any) => appliedFilter?.user_role?.includes(option.value) ) }
                                            handleChange={(e: any) => handleSelectChange(e, "user_role")}
                                            placeholder="User Role"
                                            fieldKey=""
                                            fieldSetClassName="col-md-12 "
                                        //innerClass={"select-partenrt-dropdown"}
                                        />
                                </div>
       
                            </div>

                            <div className="col-md-12">
                                <span className="date-range">User Name</span>

                                <div className="material">

                                        <ReactSelect
                                            options={userNameOptions}
                                            value={userNameOptions.filter(option => appliedFilter?.user_name?.includes(option.value) )}
                                            handleChange={(e: any) => handleSelectChange(e, "user_name")}
                                            placeholder="Select Name"
                                            fieldKey=""
                                            fieldSetClassName="col-md-12 "
                                            innerClass={"select-partenrt-dropdown"}
                                        />
                                </div>
                            </div>
                            </>
                        } */}
                        
                        {
                            filterType===FILTER_TYPE.EARNING_DETAILS && (
                                <div className="details col-md-12">
                                    <DetailRow label={translations?.COMMISSION?.VEHICLE} value={data.vehicle} />
                                    <DetailRow label={translations?.COMMISSION?.ORDER_ID} value={data.order_id} />
                                    <DetailRow label={translations?.COMMISSION?.INS_CEATION_DATE} value={HELPER.formatDate(new Date(data.created_at),'dd mon yyyy')} />
                                    <DetailRow label={translations?.COMMISSION?.INSURER} value={data.insurer_name} />
                                    <DetailRow label={translations?.COMMISSION?.PREMIUM_AMT} value={HELPER.addCurrencyFormatting(data.premium_amount)} />
                                    <DetailRow label={translations?.COMMISSION?.AGENTS_COMMISSION} value={HELPER.addCurrencyFormatting(data.agent_comission_amount)} />
                                    <DetailRow label={translations?.COMMISSION?.AGENTS_POINTS} value={data.agent_point_amount} />

                                    {
                                        mainTab ===COMMISSION_MAIN_TAB_KEY.ACTAUL_EARNING && (
                                            <div className="modal-footer">
                                            <button className="pdf-btn" onClick={() => window.open(data?.policy_documents?.find((row:any)=>row.type==="commission_invoice")?.doc_path, '_blank')}>
                                                <span className="pdf-badge">{translations?.COMMON_MSG?.PDF}</span>
                                               {translations?.COMMISSION?.COMMISSION_INVOICE}
                                            </button>

                                            <button className="pdf-btn" onClick={() => window.open(data?.policy_documents?.find((row:any)=>row.type==="point_invoice")?.doc_path, '_blank')}>
                                                <span className="pdf-badge">{translations?.COMMON_MSG?.PDF}</span>
                                                {translations?.COMMISSION?.POINTS_INVOICE}
                                            </button>

                                            <button className="download-btn" onClick={() => downloadFile(data?.policy_documents)}><i className="ic-save_alt"></i></button>
                                            </div>
                                        )
                                    }

                                </div>
                                
                            )
                        }
                        {
                            filterType==="Bank Details" && (
                                bankData?.bank_data?.map((row: any, index: number) => {
                                    return (
                                        <div className="details col-md-12" key={index}>
                                            <DetailRow label={row.label} value={""} />
                                            {index === 0 && (
                                                <span className="txt-copy space-bw" onClick={() => handleCopy(row.label)}>
                                                    <i className="ic-content_copy"></i>
                                                </span>
                                            )}
                                        </div>
                                    )
                                })
                            )
                        }
                         {
                                filterType === "Get Help" && (
                                    data?.map((item: any, index: number) => (
                                        <div className="help-item" key={index}>
                                            <h2 >
                                                {item.question}
                                            </h2>
                                            <span>
                                                {item.description}
                                            </span>
                                        </div>
                                    ))
                                )
                            }
                    </div>
                </div>
                {
                    buttonTitle && (
                        <div className='modal-footer'>
                            <button className='btn-primary btn-width-100' onClick={() => applyFilter()}>{ buttonTitle ? buttonTitle:"Submit"}</button>
                        </div>
                    )
                }
            </Modal>
            </div>
        </React.Fragment>
    );
}

export default CommonModel;    
